import { render, staticRenderFns } from "./form-component-lots.vue?vue&type=template&id=8af8a4ca"
import script from "./form-component-lots.vue?vue&type=script&lang=ts"
export * from "./form-component-lots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports